import React, {useState} from 'react';
import {CheckboxInput, FieldContainer, TextInput} from '@graffer-inc/graffer-ui';

const Main = ({ onExecute, isLoading }) => {
  const [serialNo, setSerialNo] = useState('');
  const [elCertPassword, setElCertPassword] = useState('');
  const [elCertPasswordConfirmation, setElCertPasswordConfirmation] = useState('');
  const [isRegistryCertsRegistration, setIsRegistryCertsRegistration] = useState(true);

  const isValidSerialNo = v => v.match(/[0-9]{16}/);
  const isValidElCertPassword = v => v.match(/^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{8,30}$/);
  const isValidElCertPasswordConfirmation = v => v === elCertPassword;

  const isValidAll = () => isValidSerialNo(serialNo) && isValidElCertPassword(elCertPassword) && isValidElCertPasswordConfirmation(elCertPasswordConfirmation);

  return (
    <form onSubmit={e => {
      e.preventDefault();
      onExecute({
        serialNo,
        elCertPassword,
        isRegistryCertsRegistration,
      });
    }}>
      <FieldContainer name="シリアル番号">
        <TextInput
          type="tel"
          validate={isValidSerialNo}
          errorMessage="半角数字16桁で入力してください"
          value={serialNo}
          onChange={setSerialNo}
        />
      </FieldContainer>
      <FieldContainer name="電子証明書のパスワード">
        <p className="is-size-7 has-text-grey">電子証明書の利用時に必要なパスワードです。<span className="is-highlight">再設定ができないため、忘れないよう大切に保管してください。</span></p>
        <TextInput
          type="password"
          validate={isValidElCertPassword}
          errorMessage="半角英数字をそれぞれ含む8文字以上30文字以下で入力してください"
          value={elCertPassword}
          onChange={setElCertPassword}
        />
      </FieldContainer>
      <FieldContainer name="電子証明書のパスワード(確認)">
        <TextInput
          type="password"
          validate={isValidElCertPasswordConfirmation}
          errorMessage="電子証明書のパスワードと同じ値を入力してください"
          value={elCertPasswordConfirmation}
          onChange={setElCertPasswordConfirmation}
        />
      </FieldContainer>
      <div>
        <CheckboxInput
          label="発行した電子証明書とパスワードをGrafferのアカウントに登録"
          checked={isRegistryCertsRegistration}
          onChange={v => setIsRegistryCertsRegistration(v)}
        />
        <p className="is-size-7 has-text-grey has-text-weight-normal">
          <a href="https://ttzk.graffer.jp/corporate-certs" target="_blank" rel="noopener noreferrer">Graffer  法人証明書請求</a>
          にて「印鑑証明書の郵送」を注文できるようになります。※電子証明書の登録以外にも印鑑カード番号の登録設定などが必要になります。</p>
      </div>
      <div className="has-text-centered" style={{padding: '20px 0 0 0'}}>
        <button
          type="submit"
          disabled={!isValidAll() || isLoading}
          className={`button is-accent is-rounded is-fullwidth ${isLoading ? 'is-loading' : ''}`}
        >
          登録する
        </button>
      </div>
    </form>
  );
};

export default Main;
